module.exports = __webpack_public_path__ + "img/photo10.a3d7443a.jpg";